import React, { useEffect } from 'react';
import { Form, Formik, Field, ErrorMessage } from 'formik';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { getBaseName, nl2br } from '../common/Utils';
import { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import * as Yup from "yup";

function ConsultationComment(props) {

    const { t, i18n } = useTranslation();
    const history = useHistory();

    const initValues = {
        submitBy: '',
        orgName: '',
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        country: '',
        phone: '',
        fax: '',
        respondentCategory:'',
        commentFormat:'',        
        commentText:'',
        //commentFile:'',
        attachment: null
    };

    const recaptchaSiteKey = process.env['REACT_APP_RECAPTCHA_SITE_KEY'];
    const SFCSC_DOMAIN = `${process.env['REACT_APP_SFCSC_DOMAIN']}`;

    let googleLang = "en-US";
    if (i18n.language === 'TC') {
        if (window.location.hostname === SFCSC_DOMAIN) {
            googleLang = "zh-CN";
        } else {                
            googleLang = "zh-HK";
        }
    }

    const [ item, setItem ] = useState(null);
    const params = useParams();


    useEffect(() => {
        if (item === null) {
            loadContent();
        }
    });

    const loadContent = async () => {
        const apiParams = new URLSearchParams({
            refNo: props.refNo,
            lang: params.lang
        });
        
        const apiUrl = `${getBaseName()}/api/consultation/content?${apiParams.toString()}`;
        //const apiUrl = `http://localhost:8080/edistributionWeb/api/consultation/content?${apiParams.toString()}`;
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {            
            const response = await fetch(apiUrl,options);
            const result = await response.json();
            console.log(result);
            setItem(result);
        } catch (error) {
            console.log(error);
        }
    }

    const phoneRegEx = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const SUPPORTED_FORMATS = "[application/msword:doc;application/vnd.openxmlformats-officedocument.wordprocessingml.document:docx;application/pdf:pdf;text/plain:txt]";
    const FILE_SIZE=5*1024*1024;

    const validationSchema = Yup.object().shape(
        {
            email: Yup.string().required(t("comment-form.error-msg.field.email")).email(t("comment-form.error-msg.field.email")),
            respondentType: Yup.string().required(t("comment-form.error-msg.field.respondentType")),
            orgName: Yup.string().when("respondentType", {
                is:"O", 
                then: (x) => x.required(t("comment-form.error-msg.field.orgName")).max(500, t("comment-form.error-msg.field.orgName"))
            }),
            title: Yup.string().required(t("comment-form.error-msg.field.title")),
            firstName: Yup.string().max(100, t("comment-form.error-msg.field.firstName")),
            lastName: Yup.string().required(t("comment-form.error-msg.field.lastName")).max(100, t("comment-form.error-msg.field.lastName")),
            address: Yup.string().max(1000, t("comment-form.error-msg.field.address")),
            phone: Yup.string().matches(phoneRegEx, t("comment-form.error-msg.field.phone")),
            fax: Yup.string().matches(phoneRegEx, t("comment-form.error-msg.field.fax")),
            country: Yup.string().required(t("comment-form.error-msg.field.country")),
            respondentCategory: Yup.string().required(t("comment-form.error-msg.field.respondentCategory")),
            commentFormat: Yup.string().required(t("comment-form.error-msg.field.commentFormat")),
            commentText: Yup.string().when("commentFormat", {
                is:"text",
                then: (x) => x.required(t("comment-form.error-msg.field.commentText")).max(4000, t("comment-form.error-msg.field.commentText"))
            }),
            attachment: Yup.mixed().when("commentFormat", {
                is: "attachment",
                //then: (x) => x.required(t("comment-form.validation-error.commentFile")).
                then: (x) => x.required(t("comment-form.error-msg.field.attachment"))
                    .test('fileSize', t("comment-form.error-msg.field.attachment"), value => value.size <= FILE_SIZE) 
                    .test("fileFormat", t("comment-form.error-msg.field.attachment"), value => value && SUPPORTED_FORMATS.includes(value.type) )
            })
        }
    );

    const handleRespondentTypeChange = (e,formik) => {        
        //console.log(e.target.value);
        formik.handleChange(e);
        if ("O" !== e.target.value) {
            formik.setFieldValue("orgName","");
        }
    };

    const handleCommentFormatChange = (e,formik) => {        
        //console.log(e.target.value);
        formik.handleChange(e);
        if ("attachment" == e.target.value) {
            formik.setFieldValue("commentText","");
        } else {
            //formik.setFieldValue("commentFile","");
            formik.setFieldValue("attachment",null);
        }
    };

    const handleSelectUploadFile = (e,formik) => {        
        //console.log(e.target.value);
        formik.handleChange(e);
        formik.setFieldValue("attachment",e.target.files[0]);
        //console.log(e.target.files[0]);
        //console.log(formik);
    };

    const handleFormSubmit = (values,action) => {
        console.log(values);

        if (window.grecaptcha === undefined) {
            //greacaptcha cannot be loaded
            //console.log('grecaptcha is not ready!');
        } else {            

            const formdata = new FormData();
            formdata.append("cpRefNo",item.cpRefNo);
            formdata.append("respondentType",values.respondentType);
            formdata.append("orgName",values.orgName);
            formdata.append("title",values.title);
            formdata.append("firstName",values.firstName);
            formdata.append("lastName",values.lastName);
            formdata.append("email",values.email);
            formdata.append("address",values.address);
            formdata.append("country",values.country);
            formdata.append("phone",values.phone);
            formdata.append("fax",values.fax);
            formdata.append("respondentCategory",values.respondentCategory);
            formdata.append("commentFormat",values.commentFormat);
            if (values.commentFormat === "attachment") {
                formdata.append("attachment",values.attachment);
            } else {
                formdata.append("commentText",values.commentText);
            }
            submitForm(formdata, action);
        }
    };

    const submitForm = async (formdata,{ setFieldTouched, setFieldError }) => {
        const recaptchaToken = await window.grecaptcha.execute(recaptchaSiteKey,{action:'consultation_paper_comment'});
        formdata.append("recaptchaToken",recaptchaToken);

        const apiUrl = `${getBaseName()}/api/consultation/submitcomment`;
        const options = {
            method: 'POST',
            body: formdata
        }

        try {            
            const response = await fetch(apiUrl,options);
            console.log(response);

            if (response.status === 200) {
                const result = await response.json();
                console.log(result);
                
                history.push(`/gateway/${i18n.language}/consultation/submitsuccess`);
            } else if (response.status === 400) {
                const errors = await response.json();                
                console.log(errors);

                switch (errors.type) {
                    case "validationError":
                        errors.validationErrors.map(err => {
                            if (err.field) {
                                setFieldTouched(err.field,true,false);
                                setFieldError(err.field,t(`comment-form.error-msg.field.${err.field}`));
                            }
                        });
                        break;
                    default:
                        break;                      
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
    const gaScript = `
        var _gaq = _gaq || []; 
        _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
        _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
        _gaq.push(['_trackPageview']); 
            
        (function () { 
        var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
        ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
        })();
    `;

    const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;


    return (
        <React.Fragment>
            <Helmet>
                <title>{t('comment-form.header.title')}</title>
                <script type="text/javascript" src={`//www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}&hl=${googleLang}`}></script>
                <script>{gaScript}</script>
                <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                <script>{ga4Script}</script>
            </Helmet>
            <div className='headline'>{t('comment-form.label.submit-comment-for')}{item?item.title:""}</div>
            <div className="form-holder">
            <Formik 
                initialValues={initValues}
                validationSchema={validationSchema}
                onSubmit={handleFormSubmit}>
            {(formikProps) => (
                <Form>
                    <section>
                        <h3 className="form-section-title">{t('comment-form.section.respondent-info.title')}</h3>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-title mandatory">{t('comment-form.field.respondentType')}<span>*</span></div>                                
                                <div className="field-body">
                                    <label>
                                        <Field type="radio" name="respondentType" value="O" onChange={(e)=> {handleRespondentTypeChange(e,formikProps);}}/>
                                        <span>{t('comment-form.option.organization')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="respondentType" value="I" onChange={(e)=> {handleRespondentTypeChange(e,formikProps);}}/>
                                        <span>{t('comment-form.option.individual')}</span> 
                                    </label>
                                    {formikProps.errors.respondentType && 
                                    <div class="field-body error-msg">{formikProps.errors.respondentType}</div>}
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-title">{t('comment-form.field.orgName')}</div>
                                <div className="field-body">
                                    <Field type="text" name="orgName" disabled={formikProps.values.respondentType!=="O"}/>
                                    <ErrorMessage name="orgName" component="div" className="field-body error-msg"/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-title mandatory">{t('comment-form.field.title')} <span>*</span></div>
                                <div className="field-body">
                                    <label>
                                        <Field type="radio" name="title" value="Mr"/>
                                        <span>{t('comment-form.option.mr')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="title" value="Ms"/>
                                        <span>{t('comment-form.option.ms')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="title" value="Mrs"/>
                                        <span>{t('comment-form.option.mrs')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="title" value="Dr"/>
                                        <span>{t('comment-form.option.dr')}</span>
                                    </label>
                                    <ErrorMessage name="title" component="div" className="field-body error-msg"/>
                                </div>
                            </div>
                        </div>
                        <div className={"form-row"+((formikProps.errors.firstName && formikProps.touched.firstName) || (formikProps.errors.lastName && formikProps.touched.lastName) ? ' no-margin-bottom' : '')}>
                            <div className="field-holder field-holder-half">
                                <div className="field-title">{t('comment-form.field.firstName')}</div>
                                <div className="field-body">
                                    <Field type="text" name="firstName"/>
                                </div>
                            </div>
                            <div className="field-holder field-holder-half">
                                <div className="field-title mandatory">{t('comment-form.field.lastName')} <span>*</span></div>
                                <div className="field-body">
                                    <Field type="text" name="lastName"/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row" >
                            <div className="field-holder field-holder-half">
                                <ErrorMessage name="firstName" component="div" className="field-body error-msg"/>                            
                            </div>
                            <div className="field-holder field-holder-half">
                                <ErrorMessage name="lastName" component="div" className="field-body error-msg"/> 
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder field-holder-half">
                                <div className="field-title mandatory">{t('comment-form.field.email')} <span>*</span></div>
                                <div className="field-body">
                                    <Field type="text" name="email"/>
                                    <ErrorMessage name="email" component="div" className="field-body error-msg"/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-title">{t('comment-form.field.address')}</div>
                                <div className="field-body">
                                    <Field as="textarea" name="address"/>
                                    <ErrorMessage name="address" component="div" className="field-body error-msg"/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-title">{t('comment-form.field.country')}</div>
                                <div className="field-body">
                                    <label>
                                        <Field type="radio" name="country" value="hongkong"/>
                                        <span>{t('comment-form.option.hongkong')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="country" value="china"/>
                                        <span>{t('comment-form.option.china')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="country" value="macau"/>
                                        <span>{t('comment-form.option.macau')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="country" value="other"/>
                                        <span>{t('comment-form.option.other')}</span>
                                    </label>
                                    <ErrorMessage name="country" component="div" className="field-body error-msg"/>
                                </div>
                            </div>
                        </div>
                        <div className={"form-row"+((formikProps.errors.phone && formikProps.touched.phone) || (formikProps.errors.fax && formikProps.touched.fax) ? ' no-margin-bottom' : '')}>
                            <div className="field-holder field-holder-half">
                                <div className="field-title">{t('comment-form.field.phone')}</div>
                                <div className="field-body">
                                    <Field type="text" name="phone"/>
                                </div>
                            </div>
                            <div className="field-holder field-holder-half">
                                <div className="field-title">{t('comment-form.field.fax')}</div>
                                <div className="field-body">
                                    <Field type="text" name="fax"/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row" >
                            <div className="field-holder field-holder-half">
                                <ErrorMessage name="phone" component="div" className="field-body error-msg"/>                            
                            </div>
                            <div className="field-holder field-holder-half">
                                <ErrorMessage name="fax" component="div" className="field-body error-msg"/> 
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-title mandatory">{t('comment-form.field.respondentCategory')} <span>*</span></div>
                                <div className="field-body">
                                    <label>
                                        <Field type="radio" name="respondentCategory" value="B"/>
                                        <span>{t('comment-form.option.yes')}</span>
                                    </label>
                                    <label>
                                        <Field type="radio" name="respondentCategory" value="A"/>
                                        <span>{t('comment-form.option.no')}</span>
                                    </label>
                                    <ErrorMessage name="respondentCategory" component="div" className="field-body error-msg"/>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section>
                        <h3 className="form-section-title">{t('comment-form.section.comment.title')}</h3>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-body">
                                    <label>
                                        <Field type="radio" name="commentFormat" value="attachment"
                                            onChange={(e)=> {handleCommentFormatChange(e,formikProps);}}/>
                                        <span>{t('comment-form.option.by-attachment')}</span>
                                        <ErrorMessage name="commentFormat" component="div" className="field-body error-msg"/>
                                    </label>
                                    <div className="complaint-document-uploads">
                                        <span>{t('comment-form.label.allowedFileFormatHint')}</span><br/>
                                        <input type="file" name="attachment" id="attachment" className="complaint-document-upload-input"
                                            disabled={formikProps.values.commentFormat!=="attachment"}
                                            onChange={(e)=> {handleSelectUploadFile(e,formikProps);}}/>
                                        <ErrorMessage name="attachment" component="div" className="field-body error-msg"/>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-body">
                                    <label>
                                        <Field type="radio" name="commentFormat" value="text"
                                            onChange={(e)=> {handleCommentFormatChange(e,formikProps);}}/>
                                        <span>{t('comment-form.option.by-text')}</span>
                                    </label>
                                    <Field as="textarea" name="commentText" 
                                        disabled={formikProps.values.commentFormat!=="text"}/>
                                    <ErrorMessage name="commentText" component="div" className="field-body error-msg"/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <button type="submit" className="form-submit btn btn-primary">{t('comment-form.button.submit')}</button>&nbsp;
                                <button type="reset" className="form-reset btn btn-primary btn-invert">{t('comment-form.button.reset')}</button>
                            </div>
                        </div>
                    </section>
                    
                </Form>
            )}
            </Formik>
            </div>
        </React.Fragment>
   );
}

export default ConsultationComment;

function ConsultationPaparCommentForm(props) {

    const { formik } = props;

    return (
        <Form formikProps={formik}>
            <section>
                <h3>Respondent Information</h3>
            </section>
            <section>
                <h3>Comment</h3>
            </section>
        </Form>
    )

}